export const screen = {
  mobile: '1000px'
}
